/* eslint-disable prettier/prettier */
import texts from "./ui-texts.json";

const DEFAULT_STAGE = 'default';
const STAGE = process.env.REACT_APP_STAGE || DEFAULT_STAGE;

export default (section, property, params = {}) => {
    const { template = {}, defaultValue } = params;
    const text = texts[section][property][STAGE] || texts[section][property][DEFAULT_STAGE] || defaultValue || '';
    if (typeof text === 'string') {
        return text.replace(/{(\w+)}/g, (match, key) => template[key] || match)
                   .replace(/{{/g, '{')
                   .replace(/}}/g, '}');
    }
    return text;
}